import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getMarkUp = async (query) => {
  const url = `${apiUrl}/flight/admin/markup${query ? `?${query}` : ""}`;
  const data = await httpService.get(url);
  return data;
};

const addMarkUp = async (req) => {
  try {
    const url = `${apiUrl}/flight/admin/markup`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

export { getMarkUp, addMarkUp };
